import flow from "lodash/fp/flow";
import map from "lodash/fp/map";
import find from "lodash/fp/find";
import lowerCase from "lodash/fp/lowerCase";
import moment from "moment";
import constants from "../../core/constants";

class TicketPageTransform {
  constructor(Lists) {
    "ngInject";

    this.Lists = Lists;
  }

  justify(data) {
    const states = this.Lists.all.states;
    const titles = this.Lists.all.ticketTitles;

    const formatRef = (item) => {
      const stateObj = find((state) => state.name === lowerCase(item.type))(
        states
      );
      const titleObj = find((title) => title.name === item.displayTitle)(
        titles
      );
      item.state = stateObj ? stateObj.state : null;
      item.title = titleObj ? titleObj.title : null;

      return item;
    };

    const formatDate = (item) => {
      item.createdAt = moment(item.createdAt).format(constants.dateTimeFormat);

      return item;
    };
    const formatRefs = (item) => {
      item.refs = map(formatRef)(item.refs);

      return item;
    };

    return flow([formatDate, formatRefs])(data);
  }
}

export default TicketPageTransform;



// WEBPACK FOOTER //
// ./src/pages/ticket/ticket.transforms.js